// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1vuqB","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2tHHX"};